import React, { useState, useContext } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
//Icons
import { MdDelete } from "react-icons/md";
import { ImKey } from "react-icons/im";
import { TbEdit } from "react-icons/tb";

//Srcs
import "../../Style/actionstyle.scss";
import OfficeForm from "./OfficeForm";
import Delete from "../Include/Delete"
import { DELETE_OFFICE } from "../../Schema/Office";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation } from "@apollo/client";

export default function OfficeAction({ editData, setRefetch }) {

  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);


  const [deleteOffice] = useMutation(DELETE_OFFICE, {
    onCompleted: ({ deleteOffice }) => {
      // console.log("deleteOffice::", deleteOffice);
      setLoading(false);
      if (deleteOffice?.status === true) {
        setAlert(true, "success", deleteOffice?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteOffice?.message);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteOffice({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title="កែប្រែ" placement="top">
          <IconButton
            onClick={handleOpenEdit}
          >
            <Box className="update-container">
              <TbEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title="លុប" placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      <OfficeForm
        dialogTitle="Update"
        open={openEdit}
        handleClose={handleCloseEdit}
        editData={editData}
        setRefetch={setRefetch}
      />

      <Delete
        open={openDel}
        handleClose={handleCloseDel}
        title={"ការិយាល័យ"}
        loading={loading}
        handleDelete={handleDelete}
      />
    </div>
  );
}
